import { useMemo } from 'react';

import {
  defaultPrinterQueryOptions,
  networkingHostnameQueryOptions,
  qzApiVersionQueryOptions,
} from '@goshippo/print';

import { useQuery } from '@tanstack/react-query';

import useDevice from '~/hooks/useDevice';

import { STABLE_QZ_QUERY_SETTINGS } from '../constants/qzQuery.const';
import { useShippoPrintState } from './useShippoPrintState';

export const useShippoPrintMetadata = () => {
  const connected = useShippoPrintState((state) => state.connected);

  const device = useDevice();

  const enabled = connected;

  const defaultPrinterQuery = useQuery({
    ...defaultPrinterQueryOptions,
    ...STABLE_QZ_QUERY_SETTINGS,
    enabled,
  });

  const defaultPrinter = defaultPrinterQuery.data ?? null;

  const qzApiVersionQuery = useQuery({
    ...qzApiVersionQueryOptions,
    ...STABLE_QZ_QUERY_SETTINGS,
    enabled,
  });
  const version = qzApiVersionQuery.data ?? '';

  const hostnameQuery = useQuery({
    ...networkingHostnameQueryOptions(),
    ...STABLE_QZ_QUERY_SETTINGS,
    enabled,
  });
  const hostname = hostnameQuery.data ?? '';

  /**
   * Monotonic signal that all metadata is fetched.
   */
  const isFetched =
    defaultPrinterQuery.isFetched && hostnameQuery.isFetched && qzApiVersionQuery.isFetched;

  return useMemo(
    () => ({
      connected,
      defaultPrinter,
      device,
      hostname,
      isFetched,
      version,
    }),
    [defaultPrinter, hostname, connected, device, version, isFetched],
  );
};
